module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.src
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pic mar1"
  }, [_c('img', {
    attrs: {
      "src": _vm.src2
    }
  }), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text mar1"
  }, [_c('p', [_vm._v("开放平台和共享精神")]), _vm._v(" "), _c('p', [_vm._v("接纳每一颗热衷共享的种子")]), _vm._v(" "), _c('p', [_vm._v("一同繁衍它的“城市大共享计划”")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ad"
  }, [_c('h3', [_vm._v("联系我们")]), _vm._v(" "), _c('p', {
    staticClass: "word"
  }, [_vm._v("这里不仅是球技切磋的竞技场，更是休闲放松的雅致空间。")]), _vm._v(" "), _c('p', {
    staticClass: "word"
  }, [_vm._v("我们精心打造了一个集专业与娱乐于一体的台球爱好者的梦幻之地，旨在为每一位踏入这里的您，带来无与伦比的击球体验与心灵享受。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19008824"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shareContent.vue
// module id = 157
// module chunks = 1